﻿$.fn.dxCtrlFichier2Visu = function custom_dxCtrlFichier2Visu(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-ctrlfichier2visu dx-ctrl");
        this.createInstance(new cdxCtrlFichier2Visu(this, option));
    }
    return this;
}

window.cdxCtrlFichier2Visu = function (container, option) {
    var Me = this;


    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    var $DivBt = null
    var $DivVisu = null
    function mConstruit() {
        container.empty()

        if (option.itemData == null) {
            $("<div style='width:100%;height:100%;display:flex;align-items:center;justify-content:center;font-size:160%;'>Aucun fichier</div>").appendTo(container)
        } else {
            $DivVisu = $("<div style='width:100%;height:100%;padding:30px 30px 0px 20px;'/>").appendTo(container)
            $DivBt = $("<div style='border-top:" + theme.border + ";height:42px;'/>").appendTo(container)
            mRempliBt()
            $DivVisu.css("height", "calc(100% - " + $DivBt.innerHeight() + "px)")
            resizeObserver.mAdd($DivBt, function () { $DivVisu.css("height", "calc(100% - " + $DivBt.innerHeight() + "px)") })

            var fichier = new cFichier(option.bddCtrl, option.itemData.url)
            if (fichier.mIsImage()) {
                $("<div style='width:100%;height:100%;'/>").appendTo($DivVisu).dxCtrlFichier2VisuImage({
                    bddCtrl: option.bddCtrl,
                    itemData: option.itemData,
                    readOnly: option.readOnly
                })
            } else {
                switch (fichier.mGetExtension()) {
                    case "mp4": case "webm": case "mov": case "wmv": case "mpeg": case "mpg": case "ogv":
                        fichier.mGetElementImage().attr("controls", "true").removeAttr("loop").appendTo($DivVisu)
                        $DivVisu.css({ "display": "flex", "align-items": "center", "justify-content": "center" })
                        break;
                    case "pdf":
                        if (isInAppMobile()) {
                            $("<div style='width:100%;height:100%;'/>").appendTo($DivVisu).dxCtrlFichier2VisuGoogleDrive({
                                bddCtrl: option.bddCtrl,
                                itemData: option.itemData,
                                readOnly: option.readOnly
                            })
                        } else {
                            $("<div style='width:100%;height:100%;'/>").appendTo($DivVisu).dxCtrlFichier2VisuPdf({
                                bddCtrl: option.bddCtrl,
                                itemData: option.itemData,
                                readOnly: option.readOnly
                            })
                        }
                        break;
                    case "svg":
                        $("<div style='width:100%;height:100%;'/>").appendTo($DivVisu).dxCtrlFichier2VisuSvg({
                            bddCtrl: option.bddCtrl,
                            itemData: option.itemData,
                            readOnly: option.readOnly
                        })
                        break;
                    default:
                        $("<div style='width:100%;height:100%;'/>").appendTo($DivVisu).dxCtrlFichier2VisuGoogleDrive({
                            bddCtrl: option.bddCtrl,
                            itemData: option.itemData,
                            readOnly: option.readOnly
                        })
                        break;
                }
            }
        }

    }

    function mRempliBt() {
        var fichier = new cFichier(option.bddCtrl, option.itemData.url)
        var $Table = $("<table style='width:100%;table-layout:fixed;'/>").appendTo($DivBt)
        var $Tr = $("<tr/>").appendTo($Table)
        var $Td = $("<td style='width:100%;text-overflow:ellipsis;overflow:hidden;white-space:nowrap;padding-left:10px;'>" + fichier.mGetNom() + "</td>").appendTo($Tr)
        var $Td = $("<td style='width:45px;'/>").appendTo($Tr)
        $("<div style='display:inline-block;'/>").appendTo($Td).dxCtrlButton({
            height: 40,
            width: 40,
            icon: "fas fa-cloud-arrow-up",
            onClick: function (e) {
                mDownLoadFile(option.bddCtrl, option.itemData.url)
            }
        }).dxCtrlButton("instance")

        if (fichier.mIsImage() && !option.readOnly) {
            var $Td = $("<td style='width:45px;'/>").appendTo($Tr)
            $("<div style='display:inline-block;'/>").appendTo($Td).dxCtrlButton({
                height: 40,
                width: 40,
                icon: "fas fa-pen",
                onClick: function (e) {
                    var url = option.itemData.url
                    if (url.startsWith("~")) url = url.substring(1)
                    $("<div style='height:100%;width:100%'/>").appendTo("body").dxCtrlPopupImgEdit({
                        bddCtrl: option.bddCtrl,
                        value: url + "?d=" + (new Date()).getTime(),
                        readonly: false,
                        onClose: function (data) {
                            if (typeof option.onModifFile != 'undefined') option.onModifFile()
                            mConstruit()
                        }
                    });
                }
            }).dxCtrlButton("instance")
        }

        if (typeof option.onDeleteFile != 'undefined' && !option.readOnly) {
            var $Td = $("<td style='width:45px;'/>").appendTo($Tr)
            $("<div style='display:inline-block;'/>").appendTo($Td).dxCtrlButton({
                height: 40,
                width: 40,
                icon: "fas fa-trash-alt",
                onClick: function (e) {
                    option.onDeleteFile(option.itemData)
                }
            }).dxCtrlButton("instance")
        }
    }

    this.element = function () { return container; }
    this.component = function () { return dx; }

    mConstruit();
}